import bem from 'utils/bem';

export const block = bem('upload-button');
